import React, { useContext, useState, useEffect } from 'react';
import { ThemeContext } from '../../contexts/ThemeContext';
import { LanguageContext } from '../../contexts/LanguageContext';
import { 
  StyledTestimonials, 
  TestimonialSlider, 
  TestimonialSlide, 
  TestimonialContent, 
  TestimonialControls, 
  PrevBtn, 
  NextBtn, 
  Dots, 
  Dot 
} from './styles';

const Testimonials = () => {
  const { theme } = useContext(ThemeContext);
  const { language, translations } = useContext(LanguageContext);
  const [currentSlide, setCurrentSlide] = useState(0);

  // Criar o array com base nas traduções
  const testimonials = [
    {
      quote: translations[language].testimonial1,
      client: translations[language].testimonial1Client
    },
    {
      quote: translations[language].testimonial2,
      client: translations[language].testimonial2Client
    },
    {
      quote: translations[language].testimonial3,
      client: translations[language].testimonial3Client
    },
    {
      quote: translations[language].testimonial4,
      client: translations[language].testimonial4Client
    },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 20000);
    return () => clearInterval(interval);
  }, []);

  return (
    <StyledTestimonials>
      <div className="container">
        <h2 dangerouslySetInnerHTML={{ __html: translations[language].testimonialsTitle }} />
        <TestimonialSlider>
          {testimonials.map((testimonial, index) => (
            <TestimonialSlide key={index} className={index === currentSlide ? 'active' : ''}>
              <TestimonialContent>
                <div className="quote">
                  <i className="fas fa-quote-left"></i>
                </div>
                <p>{testimonial.quote}</p>
                <div className="client">
                  <strong>{testimonial.client}</strong>
                </div>
              </TestimonialContent>
            </TestimonialSlide>
          ))}
          <TestimonialControls>
            <PrevBtn onClick={prevSlide}>
              <i className="fas fa-chevron-left"></i>
            </PrevBtn>
            <Dots>
              {testimonials.map((_, index) => (
                <Dot 
                  key={index} 
                  className={index === currentSlide ? 'active' : ''} 
                  onClick={() => goToSlide(index)}
                />
              ))}
            </Dots>
            <NextBtn onClick={nextSlide}>
              <i className="fas fa-chevron-right"></i>
            </NextBtn>
          </TestimonialControls>
        </TestimonialSlider>
      </div>
    </StyledTestimonials>
  );
};

export default Testimonials;
